export default {
  defaultNodeWidth: 200,
  defaultNodeHeight: 100,
  defaultNodeFont: '30px Arial',
  defaultLinkThickness: 2,

  nodeFonts: [
    { label: 'Arial Small', value: '15px Arial' },
    { label: 'Arial Medium', value: '30px Arial' },
    { label: 'Arial Large', value: '45px Arial' }
  ]
}
